import { FileFieldCellDto } from '@/components/table/_fieldDefinitions/file/FileFieldCellDto.ts';

export const fileExportRender = (value: unknown): string => {
  const file = value as FileFieldCellDto | null | undefined;
  if (!file) return '';
  return file.fileName ?? '';
};
